const schema = () => ({
  type: "object",
  required: [],
  properties: {
    location: {
      type: "object",
      title: "آدرس",
    },
    title: {
      type: "string",
      title: "عنوان",
    },
    manager_id: {
      type: "string",
      title: "مدیر",
    },
    is_active: {
      type: "number",
      title: "وضعیت",
      oneOf: [
        { const: 1, title: "فعال" },
        { const: 0, title: "غیرفعال" },
      ],
    },
  },
});

export default schema;
